<template>
  <div class="card mb-25 border-0 rounded-0 mb-20">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <h5 class="card-title fw-black mb-0">Statistiques 12 Dérnier Mois</h5>
        </div>
        <div class="row mb-10">
          <div class="col-12">
            <button
              class="btn btn-success"
              v-if="auth.can('EXPORT_DASH')"
              @click="exportData"
            >
              <i class="flaticon-download"></i>
              Excel
            </button>
            <button class="btn btn-primary" @click="searchData" :disabled="isLoader">
              <i class="flaticon-search"></i>
              <div class="spinner-border" role="status" v-if="isLoader">
                <span class="visually-hidden">Loading...</span>
              </div>
              Chercher
            </button>
          </div>
        </div>
      </div>

      <div
        class="chart"
        :style="[isLoader ? { 'pointer-events': 'none', opacity: '0.08' } : '']"
        v-if="show"
      >
        <apexchart
          type="bar"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const auth = useAuthStore();
    const user = auth.user;

    const isLoader = ref(false);
    const show = ref(false);
    const series = ref([
      {
        name: "Livrés",
        data: [],
      },
      {
        name: "En Cours",
        data: [],
      },
      {
        name: "Retournés",
        data: [],
      },
    ]);
    const chartOptions = ref({
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#F1C40F", "#E74C3C", "#27AE60"],
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: "Total Colis",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: (val: number) => {
            return val + " Colis";
          },
        },
      },
    });
    const exportData = async () => {
      try {
        const res = await api.get("/api/auth/ExcelTopData?type=LastMonth", {
          responseType: "arraybuffer",
        });
        const fileURL = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "StatisticYear.xlsx";
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);
      } catch (error) {
        console.error("Export failed:", error);
      }
    };

    const searchData = async () => {
      isLoader.value = true;
      try {
        const res = await api.get("/api/auth/Last12MonthData");

        // Update series (ok to replace directly)
        series.value = res.data.data;

        // Replace chartOptions object so ApexCharts detects the change
        chartOptions.value = {
          ...chartOptions.value,
          colors: res.data.colors,
          xaxis: {
            ...chartOptions.value.xaxis,
            categories: res.data.months,
          },
        };

        show.value = true;
      } catch (error) {
        console.error("Search failed:", error);
      } finally {
        isLoader.value = false;
      }
    };

    return {
      isLoader,
      show,
      series,
      chartOptions,
      searchData,
      exportData,
      auth,
    };
  },
});
</script>
